<template>
  <div class="grey lighten-3 pt-3 mt-5" style="min-height:100%;margin: 0 auto;">
    <v-layout
      row
      wrap
      style="background-color:white; height:30px; width:100%; top:135px; position:fixed; z-index: 1; height:50px;"
    >
      <v-flex xs12> </v-flex>
    </v-layout>

    <v-toolbar
      mx-0
      px-3
      ml-0
      pt-0
      pb-3
      color="white"
      tabs
      class="elevation-1  mt-3"
      style="z-index:1; top:135px; position:fixed; width:100%; border-bottom: 1px solid #999; background-color: #fff; "
    >
      <!-- <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn> -->
      <v-flex class="xs8 pl-1 ml-0 mr-0">
        <h4 class="pl-3 headline font-weight-light" v-html="exhibition.title">
          <!-- {{exhibition.title}} -->
        </h4>
        <!-- <v-spacer></v-spacer>
        <a class="headline mr-2 pr-2 black--text" @click="options=false;$router.go(-1)">close</a> -->
      </v-flex>
      <v-layout class="xs4 my-0 pr-2 pt-1 justify-end column">
        <v-flex class="xs4 pl-3 ml-0 mr-0 text-xs-right">
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn
            @click="
              options = false;
              $router.go(-1);
            "
            icon
            class="mx-0 mt-0"
            style="height:30px !important;"
          >
            <v-icon color="black">close</v-icon>
          </v-btn> -->

          <v-btn
            v-if="c_user.delete_rights"
            small
            icon
            class="mr-3"
            @click="deleteExhibition()"
            right
          >
            <v-icon small color="red">delete</v-icon>
          </v-btn>
          <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
            <v-icon small>close</v-icon>
          </v-btn>
          <v-btn
            v-if="c_user.edit"
            icon
            small
            :disabled="!valid"
            @click="saveExhibition"
            right
          >
            <v-icon small>save</v-icon>
          </v-btn>

          <!-- <a class="headline mr-2 pr-2 black--text" @click="options=false;$router.go(-1)">close</a> -->
        </v-flex>
      </v-layout>
    </v-toolbar>
    <!-- <v-toolbar tabs color="white elevation-0" style="top:67px; position:fixed; z-index: 1;">
      <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
      <v-toolbar-title class="ml-4">{{exhibition.title}} </v-toolbar-title>
      <v-menu bottom right>
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="addToSelection(exhibition.id)">
            <v-list-tile-title>Add this artwork to list</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>       -->
    <!-- <v-btn icon><v-icon>more_vert</v-icon></v-btn> -->
    <!-- <small v-if="artworkFormData.artist">{{artworkFormData.artist.name}}</small> -->
    <!-- <v-tabs slot="extension" color="transparent" slider-color="purple"  align-with-title v-model="currentTab" show-arrows>
        <v-tab v-for="tab in fields.tabs" :ripple="false"
          :key="tab.key"
          :href="'#tab-' + tab.key" 
          @click="saveCurrentTab('tab-' + tab.key)"
          v-if="tab.work_types && tab.work_types.includes(artworkFormData.classification)"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs> -->
    <!-- </v-toolbar> -->

    <v-form @submit.prevent ref="form" v-model="valid" lazy-validation>
      <v-card class="px-3 pt-0 mt-3 elevation-0 editBG">
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex
              style="background-color:#292929; color: #eee;"
              class="px-3 py-0 my-3 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Basic</h3>
            </v-flex>

            <v-flex xs12 class="px-4">
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.title"
                label="Title"
              ></v-text-field>

              <v-flex v-else mt-4>
                <code>{{ exhibition.title }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Title</label>
              </v-flex>

            </v-flex>

            <v-flex xs12 class="px-4 mb-3">
              <v-autocomplete class=""
                hide-details
                v-if="c_user.edit"
                label="Institution"
                :items="institutions"
                v-model="exhibition.institution_id"
                item-value="id"
                item-text="name"
              ></v-autocomplete>

              <v-flex v-else mt-3>
                <code>{{ getInstitutionName(exhibition.institution_id) }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Institution</label>
              </v-flex>

              <!-- <small class="grey--text lighten-2">Old institution: {{ exhibition.institution }}</small> -->
              <!-- <v-text-field
                :disabled="!c_user.edit"
                v-model="exhibition.institution"
                label="Institution"
              ></v-text-field> -->
            </v-flex>

            <v-flex xs12 sm6 class="px-4">
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.city"
                label="City"
              ></v-text-field>

              <v-flex v-else>
                <code>{{ exhibition.city }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">City</label>
              </v-flex>

            </v-flex>

            <v-flex xs12 sm6 class="px-4">
              <v-autocomplete
                v-if="c_user.edit"
                :items="countries"
                v-model="exhibition.country"
                label="Country"
              ></v-autocomplete>

              <v-flex v-else>
                <code>{{ exhibition.country }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Country</label>
              </v-flex>

            </v-flex>

            <v-flex xs12 sm4 md2 lg2 class="pl-4 pr-3">
              <v-text-field
                v-model="exhibition.duration_start_year"
                v-if="c_user.edit"
                label="Start Year"
                placeholder="XXXX"
                type="number"
                :maxlength="4"
              ></v-text-field>

              <v-flex v-else mt-3>
                <code>{{ exhibition.duration_start_year }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Start Year</label>
              </v-flex>

            </v-flex>
            <v-flex xs6 sm4 md2 lg2 pr-3>
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.duration_start_month"
                label="Month"
                placeholder="XX"
                type="number"
              ></v-text-field>

              <v-flex v-else mt-3>
                <code>{{ exhibition.duration_start_month }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Month</label>
              </v-flex>

            </v-flex>
            <v-flex xs6 sm4 md2 lg2 class="pr-4">
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.duration_start_day"
                label="Day"
                placeholder="XX"
                type="number"
              ></v-text-field>

              <v-flex v-else mt-3>
                <code>{{ exhibition.duration_start_day }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Day</label>
              </v-flex>

            </v-flex>

            <v-flex xs12 sm4 md2 lg2 class="px-4">
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.duration_end_year"
                label="End Year"
                placeholder="XXXX"
                type="number"
              ></v-text-field>

              <v-flex v-else mt-3>
                <code>{{ exhibition.duration_end_year }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">End Year</label>
              </v-flex>

            </v-flex>
            <v-flex xs6 sm4 md2 lg2 pr-3>
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.duration_end_month"
                label="Month"
                placeholder="XX"
                type="number"
              ></v-text-field>

              <v-flex v-else mt-3>
                <code>{{ exhibition.duration_end_month }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Month</label>
              </v-flex>

            </v-flex>
            <v-flex xs6 sm4 md2 lg2 pr-4>
              <v-text-field
                v-if="c_user.edit"
                v-model="exhibition.duration_end_day"
                label="Day"
                placeholder="XX"
                type="number"
              ></v-text-field>

              <v-flex v-else mt-3>
                <code>{{ exhibition.duration_end_day }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Day</label>
              </v-flex>

            </v-flex>

            <!-- <v-flex xs12 sm6 md6 class="px-5 pt-3"> -->
            <!-- <v-radio-group v-model="exhibition.show_type" row>
                <v-radio label="Group Show" input-value="2" value="2" class='pr-5'></v-radio>
                <v-radio label="Solo Show" input-value="1" value="1"></v-radio>
              </v-radio-group> -->

            <v-flex xs12 sm6 class="py-2 px-4 pt-4">
              <v-btn-toggle v-if="c_user.edit" v-model="exhibition.show_type">
                <v-btn
                  small
                  flat
                  key="group"
                  class="px-2"
                  input-value="2"
                  value="2"
                >
                  <span> Group Show </span>
                </v-btn>
                <v-btn
                  small
                  flat
                  key="solo"
                  class="px-2"
                  input-value="1"
                  value="1"
                >
                  <span> Solo Show </span>
                </v-btn>
              </v-btn-toggle>
              <span v-else class="ml-2">{{
                exhibition.show_type == 2 ? 'Group Show' : 'Solo Show'
              }}</span>
            </v-flex>
            <!-- </v-flex> -->

            <v-flex xs12 sm6 md6 pt-3 class="px-4">
              <v-switch
                v-if="c_user.edit"
                v-model="exhibition.loan"
                label="Loan"
                color="black"
                input-value="1"
              ></v-switch>

              <v-flex v-else>
                <code>{{ exhibition.loan == 1 ? 'Yes' : 'No' }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Loan</label>
              </v-flex>

            </v-flex>

            <v-flex xs12 sm12 md12 px-4>
              <v-textarea
                v-if="c_user.edit"
                outline
                v-model="exhibition.admin_note"
                label="Note"
                auto-grow
                clearable
                rows="1"
              ></v-textarea>

              <v-flex v-else mt-3>
                <code>{{ exhibition.admin_note }}</code>
                <!-- <label v-if="label != ''">{{ label }}</label> -->
                <label style="color:#999;">Note</label>
              </v-flex>

            </v-flex>
            <v-flex xs12 px-4 mt-4>
              <!-- <v-autocomplete
                v-model="exhibition.artworks"
                :items="artworks"
                label="Artworks" item-text="title" item-value="id" multiple chips
              ></v-autocomplete> -->

              <!-- <v-combobox v-model="exhibition.artworks" :items="artworks" label="I use a scoped slot" multiple chips :item-text="item => item.title + ', ' + item.accession_number + ', ' + item.name" item-value="id">
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    class="v-chip--select-multi"
                    @input="data.parent.selectItem(data.item)"
                  >
                    <v-avatar class="accent white--text" v-text="data.item.title" ></v-avatar>
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-combobox> -->

              <!-- <v-combobox
                v-model="exhibition.artworks" chips clearable multiple open-on-clear
                :items="artworks"
                :item-text="item => item.title + ', ' + item.accession_number + ', ' + item.name" item-value="id"
                label="Exhibition Artworks"
                >
                <template v-slot:selection="data">
                  <v-chip :selected="data.selected" :disabled="data.disabled" close @input="remove(data.item)" :key="JSON.stringify(data.item)" class="v-chip--select-multi">
                    <strong v-html="data.item.title"></strong>&nbsp;
                    <span>{{data.item.accession_number}} </span>&nbsp;
                    <strong v-html="data.item.name"></strong>
                  </v-chip>
                </template>
              </v-combobox> -->
              <!-- prepend-icon="filter_list" -->
              <!-- <template v-slot:item="data">
                menu-props='{"closeOnClick":false, "closeOnContentClick":false, "openOnClick":false, "maxHeight":600}'
                  <div
                    :key="data.item.id"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    @input="data.parent.selectItem(data.item)"
                  >
                  <v-checkbox value="data.item.selected"></v-checkbox>
                    {{ data.item.title }}
                  </div>
                </template> -->

              <div v-if="exhibition.artworks">
                {{ exhibition.artworks.length }} Artworks:
              </div>
              <!-- color="grey lighten-4"  -->
              <v-autocomplete
                v-model="exhibition.artworks"
                :disabled="!c_user.edit ||isUpdating"
                :items="artworks_store"
                multiple
                box
                chips
                small-chips
                hide-no-data
                hide-selected
                :label="
                  artworks_store.length > 0
                    ? 'Select Artworks'
                    : 'Artwoks not yet loaded. Please wait...'
                "
                item-value="id"
                :item-text="
                  item =>
                    item.title + ', ' + item.accession_number + ', ' + item.name
                "
                :loading="!artworks_store.length > 0"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi white--text chip--select-multi"
                    @input="remove(data.item.id)"
                    color="black"
                  >
                    <!-- <v-avatar> <img :src="data.item.avatar"> </v-avatar>  -->
                    <strong v-html="data.item.title"></strong>&nbsp;
                    <span>{{ data.item.accession_number }} </span>&nbsp;
                    <strong v-html="data.item.name"></strong>
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <!-- <v-list-tile-avatar>
                    <img :src="data.item.avatar">
                  </v-list-tile-avatar> -->
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <strong v-html="data.item.title"></strong>&nbsp;
                      <span>{{ data.item.accession_number }} </span>&nbsp;
                      <strong v-html="data.item.name"></strong>
                    </v-list-tile-title>
                    <v-list-tile-sub-title></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>

              <!-- <v-autocomplete box multiple chips color="blue-grey lighten-3" label="Artworks" item-text="title" item-value="id" clearable
                v-model="exhibition.artworks"
                :items="artworks"
              >
                <template v-slot:selection="data">
                  <v-chip close class="chip--select-multi white--text" color="black"
                    :selected="data.selected" @input="remove(data.item)" 
                  >
                    {{ data.item.title }}
                  </v-chip>
                </template>

                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content class="my-4">
                      <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
                      <v-list-tile-sub-title>{{data.item.accession_number}} <b>{{ (data.item.artist ? data.item.artist.name : data.item.name) }}</b></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete> -->

              <!-- {{this.testd}} -->
            </v-flex>

            <!-- <v-layout align-center justify-start mx-3 mt-4>
              <v-btn color="red" small v-if="c_user.delete_rights" outline @click="deleteExhibition()">delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="black" flat small @click="$router.go(-1)">CANCEL</v-btn>
              <v-btn color="black" small dark v-if="c_user.edit" @click="saveExhibition()">SAVE</v-btn>
            </v-layout> -->
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from 'axios'
import { serverBus } from '@/main'
import constants from '@/data/constants'
export default {
  data() {
    return {
      autoUpdate: true,
      isUpdating: false,
      snackbar: false,
      color: 'black',
      snackbar_text: '',
      timeout: 3500,
      valid: true,
      countries: [],
      dialog: false,
      exhibition: {
        loan: '',
        title: 'loading...',
        institution: '',
        show_type: '',
        city: '',
        country: '',
        duration_start_year: null,
        duration_start_month: null,
        duration_start_day: null,
        duration_end_year: null,
        duration_end_month: null,
        duration_end_day: null,
        admin_note: ''
      },
      // artworks: [],
      constants: constants
    }
  },
  created() {
    this.countries = this.constants.COUNTRIES
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    }
  },
  methods: {
    // remove (item) {
    //   this.exhibition.artworks.splice(this.exhibition.artworks.indexOf(item), 1)
    //   this.exhibition.artworks = [...this.exhibition.artworks]
    // },
    remove(item) {
      // this.exhibition.artworks.splice(this.exhibition.artworks.indexOf(item), 1)
      // this.exhibition.artworks = [...this.exhibition.artworks]
      // console.log(item)
      // console.log(this.exhibition.artworks)
      const index = this.exhibition.artworks.indexOf(item)
      // console.log(index)
      if (index >= 0) this.exhibition.artworks.splice(index, 1)
    },
    saveExhibition() {
      this.exhibition.duration_end = this.exhibition_duration_end
      // this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      this.exhibition.duration_start = this.exhibition_duration_start
      // this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');

      // this.exhibition.duration_end = this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      // this.exhibition.duration_start = this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');
      // this.exhibition.artworks = this.artwork_ids
      // console.log(this.exhibition.artworks)

      this.exhibition.artwork_ids = this.exhibition.artworks
      // .map(a => a.id)
      // console.log(this.exhibition)
      // this.exhibition.artworks = this.exhibition.artwork_ids
      let url = `${this.$globals.apiserver}/exhibitions/${this.exhibition.id}.json`
      axios
        .put(url, { exhibition: this.exhibition })
        .then(response => {
          this.result = response.data
          serverBus.$emit('showSnackbar', 'Exhibition was saved.', 'green')
        })
        .catch(error => {
          serverBus.$emit(
            'showSnackbar',
            'Exhibition was NOT saved. Error occured.',
            'red'
          )
          // console.log(error)
        })
    },
    deleteExhibition() {
      let url = `${this.$globals.apiserver}/exhibitions/${this.exhibition.id}.json`
      axios
        .delete(url, this.exhibition)
        .then(response => {
          this.result = response.data
          serverBus.$emit('showSnackbar', 'Exhibition was deleted.', 'green')
          this.$router.push({ name: 'ExhibitionIndex' })
        })
        .catch(error => {
          serverBus.$emit(
            'showSnackbar',
            'Exhibition was NOT deleted. Error occured.',
            'red'
          )
          // console.log(error)
        })
    },
    getExhibition() {
      let url = `${this.$globals.apiserver}/exhibitions/${this.$route.params.id}.json`
      axios
        .get(url)
        .then(response => {
          this.exhibition = response.data
          // MUSIM ZMENIT VALUE PRE RADIO GROUP NA STRING LEBO INAK TO NEFUNGUJE
          if (this.exhibition.show_type) {
            this.exhibition.show_type = this.exhibition.show_type.toString()
          }
          // console.log('this.exhibition')
          // console.log(this.exhibition)
          this.exhibition.artworks = this.exhibition.artworks.map(a => a.id)
          // console.log(this.exhibition.artworks)
        })
        .catch(error => {
          serverBus.$emit(
            'showSnackbar',
            'Exhibition could NOT be loaded. Error occured.',
            'red'
          )
          // console.log(error)
        })
    }
  },
  computed: {
    institutions() {
      return this.$store.state.contacts.filter(
        c => c.category == 'exhibition_institution'
      )
    },
    artworks_store() {
      return this.$store.state.artworks
    },
    exhibition_duration_end() {
      return `${this.exhibition.duration_end_year}-${this.exhibition.duration_end_month}-${this.exhibition.duration_end_day}`
    },
    exhibition_duration_start() {
      return `${this.exhibition.duration_start_year}-${this.exhibition.duration_start_month}-${this.exhibition.duration_start_day}`
    },
    artwork_ids() {
      let mm = []
      this.exhibition.artworks.forEach(a => mm.push({ id: a.id }))
      return mm
    }
  },
  beforeMount() {
    // this.exhibition = Object.assign({},this.$route.params.exhibition)
    this.getExhibition()
  }
}
</script>

<style scoped>
.theme--light.v-input--is-disabled .v-label,
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: rgba(0, 0, 0, 0.6) !important;
}

code {
  border: 0px;
  color: black;
  box-shadow: none;
  font-family: Arial !important;
  font-weight: 100;
  background: none !important;
  font-size: 16px;
  line-height: 17px;
  margin-top: 0px;
  padding-left: 0px;
}
code::before {
  content: '';
}
label {
  color: rgb(128, 128, 128) !important;
  border-top: 1px solid black;
  margin-top: 0px !important;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/exhibitions/EditExhibition.vue